import { useContext, useEffect, useState } from "react"
import CloseIcon from "../../../assets/icons/CloseIcon"
import Button from "../../atoms/Button"
import RcmpDatePicker from "../../atoms/DatePicker"
import Select from "../../atoms/Select"
import styles from "./index.module.scss"
import BoardContext from "../../../contexts/Board"
import { Input } from "@stardust-ds/react"
import { BlocksContext } from "../../../contexts/Blocks"
import { FormProvider, useForm } from "react-hook-form"
import { fnListBlocks } from "../../../services/blocks"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import RcmpFormErrorMessage from "../../atoms/FormErrorMessage"
import {
  fnFormatDateFromUTCFromDate,
  fnFormatDateToUTC,
  fnFormatDateToUTCFromDate,
} from "../../../utils/date"
import { FilterContext } from "../../../contexts/Filter"
import AuthContext from "../../../contexts/Auth"
import { NumericFormat } from "react-number-format"
import moment from "moment"
import RcmpSelectUsers from "../SelectUsers"

const cSchemaPrefix = "model-field-"
const fnCreateYupSchema = (fields, requiredFields) => {
  const schema = {}
  requiredFields.forEach((field) => {
    switch (field.opfd_ctype) {
      case "DATE":
        schema[`${cSchemaPrefix}${field.opfd_nid}-start`] = yup.mixed().nullable()
        schema[`${cSchemaPrefix}${field.opfd_nid}-end`] = yup
          .mixed()
          .nullable()
          .default(undefined)
          .test(
            "big-than-start",
            "Data ou hora final não pode ser menor que a inicial.",
            function (value) {
              const startDate = this.parent[`${cSchemaPrefix}${field.opfd_nid}-start`]
              const valueIsValid = moment(value).isValid() && !(value instanceof Array)
              const startDateIsValid =
                moment(startDate).isValid() && !(startDate instanceof Array)
              if (valueIsValid && startDateIsValid) {
                return moment(value).isAfter(moment(startDate))
              }
              return true
            },
          )
          .test(
            "not-start-is-empty",
            "Os dois campos devem ser preenchidos",
            function (value) {
              const startDate = this.parent[`${cSchemaPrefix}${field.opfd_nid}-start`]
              const valueIsValid = moment(value).isValid() && !(value instanceof Array)
              const startDateIsValid =
                moment(startDate).isValid() && !(startDate instanceof Array)
              if (!valueIsValid && startDateIsValid) {
                return false
              }
              return true
            },
          )
          .when(`${cSchemaPrefix}${field.opfd_nid}-start`, {
            is: (val) => val !== null,
            then: (schema) => schema.required("Preencha os dois campos"),
          })
        /*  .transform((curr, orig) => {
            if (!orig || orig?.length == 0) {
              return ""
            } else {
              return new Date(
                fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
              )
            }
          }) */
        break
      case "PEOPLES":
        schema[`${cSchemaPrefix}${field.opfd_nid}-responsible`] = yup.mixed().nullable()
        /* .transform((curr, orig) => {
            if (curr !== null) {
              return String(curr.value)
            }
            return null
          }) */
        break
    }
  })
  //const schema = {
  //  "model-field-7-people": yup.mixed().nullable(),
  //  /* .transform((curr, orig) => {
  //      if (curr !== null) {
  //        return String(curr.value)
  //      }
  //      return null
  //    }), */
  //  "model-field-6-start": yup.mixed().nullable(),
  //  "model-field-6-end": yup
  //    .mixed()
  //    .nullable()
  //    .default(null)
  //    .test(
  //      "big-than-start",
  //      "Data ou hora final não pode ser menor que a inicial.",
  //      function (value) {
  //        const startDate = this.parent[`${cSchemaPrefix}6-start`]
  //        const valueIsValid = moment(value).isValid() && !(value instanceof Array)
  //        const startDateIsValid =
  //          moment(startDate).isValid() && !(startDate instanceof Array)
  //        if (valueIsValid && startDateIsValid) {
  //          console.log("dentro do if: ", {
  //            value: moment(value).toDate(),
  //            startDate: moment(startDate).toDate(),
  //          })
  //          return moment(value).isAfter(moment(startDate))
  //        }
  //        return true
  //      },
  //    )
  //    .test(
  //      "not-start-is-empty",
  //      "Os dois campos devem ser preenchidos",
  //      function (value) {
  //        const startDate = this.parent[`${cSchemaPrefix}6-start`]
  //        const valueIsValid = moment(value).isValid() && !(value instanceof Array)
  //        const startDateIsValid =
  //          moment(startDate).isValid() && !(startDate instanceof Array)
  //        if (!valueIsValid && startDateIsValid) {
  //          return false
  //        }
  //        return true
  //      },
  //    ),
  //  "model-field-5-start": yup
  //    .mixed()
  //    .nullable()
  //    .transform((curr, orig) => {
  //      if (!orig || orig?.length == 0) {
  //        return ""
  //      } else {
  //        return new Date(
  //          fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
  //        )
  //      }
  //    }),
  //  "model-field-5-end": yup
  //    .mixed()
  //    .nullable()
  //    .default(null)
  //    .test(
  //      "big-than-start",
  //      "Data ou hora final não pode ser menor que a inicial.",
  //      function (value) {
  //        const startDate = this.parent[`${cSchemaPrefix}5-start`]
  //        const valueIsValid = moment(value).isValid() && !(value instanceof Array)
  //        const startDateIsValid =
  //          moment(startDate).isValid() && !(startDate instanceof Array)
  //        if (valueIsValid && startDateIsValid) {
  //          console.log("dentro do if: ", {
  //            value: moment(value).toDate(),
  //            startDate: moment(startDate).toDate(),
  //          })
  //          return moment(value).isAfter(moment(startDate))
  //        }
  //        return true
  //      },
  //    )
  //    .test(
  //      "not-start-is-empty",
  //      "Os dois campos devem ser preenchidos",
  //      function (value) {
  //        const startDate = this.parent[`${cSchemaPrefix}5-start`]
  //        const valueIsValid = moment(value).isValid() && !(value instanceof Array)
  //        const startDateIsValid =
  //          moment(startDate).isValid() && !(startDate instanceof Array)
  //        if (!valueIsValid && startDateIsValid) {
  //          return false
  //        }
  //        return true
  //      },
  //    )
  //    .transform((curr, orig) => {
  //      if (!orig || orig?.length == 0) {
  //        return ""
  //      } else {
  //        return new Date(
  //          fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
  //        )
  //      }
  //    }),
  //}
  //required filters
  /*   const requiredFilters = fields.filter(
    (field) =>
      field.opfd_cslug === "act_responsibles" ||
      field.opfd_cslug === "data_de_conclusao" ||
      field.opfd_cslug === "data_de_criacao",
  )
  requiredFilters.forEach((field) => {
    switch (field.opfd_cslug) {
      case "DATE":
    }
  })
  const anotherFields = fields.filter(
    (field) =>
      field.opfd_cslug !== "act_responsibles" &&
      field.opfd_cslug !== "data_de_conclusao" &&
      field.opfd_cslug !== "data_de_criacao",
  ) */
  fields.forEach((field) => {
    switch (field.opfd_ctype) {
      case "DATE":
        schema[`${cSchemaPrefix}${field.opfd_nid}-start`] = yup.mixed().nullable()
        schema[`${cSchemaPrefix}${field.opfd_nid}-end`] = yup
          .mixed()
          .nullable()
          .default(undefined)
          .test(
            "big-than-start",
            "Data ou hora final não pode ser menor que a inicial.",
            function (value) {
              const startDate = this.parent[`${cSchemaPrefix}${field.opfd_nid}-start`]
              const valueIsValid = moment(value).isValid() && !(value instanceof Array)
              const startDateIsValid =
                moment(startDate).isValid() && !(startDate instanceof Array)
              if (valueIsValid && startDateIsValid) {
                return moment(value).isAfter(moment(startDate))
              }
              return true
            },
          )
          .test(
            "not-start-is-empty",
            "Os dois campos devem ser preenchidos",
            function (value) {
              const startDate = this.parent[`${cSchemaPrefix}${field.opfd_nid}-start`]
              const valueIsValid = moment(value).isValid() && !(value instanceof Array)
              const startDateIsValid =
                moment(startDate).isValid() && !(startDate instanceof Array)
              if (!valueIsValid && startDateIsValid) {
                return false
              }
              return true
            },
          )
          .when(`${cSchemaPrefix}${field.opfd_nid}-start`, {
            is: (val) => val !== null,
            then: (schema) => schema.required("Preencha os dois campos"),
          })
        /*  .transform((curr, orig) => {
            if (!orig || orig?.length == 0) {
              return ""
            } else {
              return new Date(
                fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
              )
            }
          }) */
        break
      case "TEXT":
        schema[`${cSchemaPrefix}${field.opfd_nid}`] = yup
          .string()
          .nullable()
          .test(
            "not-empty-values",
            "O campo de texto não podem ser aceito apenas com caractere de espaço.",
            (value) => {
              if (value && value !== null && value !== "") {
                return value.trim().length > 0
              }
              return true
            },
          )

        break
      case "NUMBER":
        schema[`${cSchemaPrefix}${field.opfd_nid}-number`] = yup
          .string()
          .nullable()
          .test(
            "not-empty-values",
            "O campo de número não podem ser aceito apenas com caractere de espaço.",
            (value) => {
              if (value && value !== null && value !== "") {
                return value.trim().length > 0
              }
              return true
            },
          )

        break
      case "SELECTION":
        schema[`${cSchemaPrefix}${field.opfd_nid}-select`] = yup.mixed().nullable()
        /* .transform((curr, orig) => {
            if (curr !== null) {
              return String(curr.value)
            }
            return null
          }) */
        break
      case "PEOPLES":
        schema[`${cSchemaPrefix}${field.opfd_nid}-responsible`] = yup.mixed().nullable()
        /* .transform((curr, orig) => {
            if (curr !== null) {
              return String(curr.value)
            }
            return null
          }) */
        break
      default:
        break
    }
  })

  return yup.object().shape(schema)
}
const fnCreateDefaultValues = (fields, oFilterData) => {
  if (oFilterData) return oFilterData
  const defaultValues = {}
  fields.length > 0 &&
    fields.forEach((field) => {
      if (field.opfd_ctype === "DATE") {
        defaultValues[`${cSchemaPrefix}${field.opfd_nid}-start`] = ""
        defaultValues[`${cSchemaPrefix}${field.opfd_nid}-end`] = ""
        return
      }
      if (field.opfd_ctype === "PEOPLES") {
        defaultValues[`${cSchemaPrefix}${field.opfd_nid}-responsible`] = ""
        return
      }
      if (field.opfd_ctype === "SELECTION") {
        defaultValues[`${cSchemaPrefix}${field.opfd_nid}-select`] = ""
        return
      }
      defaultValues[`${cSchemaPrefix}${field.opfd_nid}`] = ""
    })

  return defaultValues
}

export default function ModalFilter(props) {
  const {
    fnHandleOpenFilter,
    fnHandleActivateFilter,
    fnHandleClearFilter,
    aAllFieldsFiltered,
    aRequiredFields = [],
  } = props

  const { oCurrentBoard, oBoardRes } = useContext(BoardContext)
  const { fnSetABlocks } = useContext(BlocksContext)
  const { fnPrepareFilters, oFilterData, fnSetOCurrentBoard, aFilters, bFilterIsActive } =
    useContext(FilterContext)
  const { oUser } = useContext(AuthContext)

  const [responsiblesOptions, fnSetResponsiblesOptions] = useState([])
  const [oDefaultValues, fnSetODefaultValues] = useState({})
  const [testeSchema, setTesteSchema] = useState(
    fnCreateYupSchema(aAllFieldsFiltered, aRequiredFields),
  )
  const [forceRender, fnSetForceRender] = useState("")

  const cUserTimeZone = oUser?.data?.user_ctimezone
  const oBOardModel = oCurrentBoard.board_model || oCurrentBoard.data[0].board_model
  //create function to create yup schema from fields by type

  const modelSchema = fnCreateYupSchema(aAllFieldsFiltered, aRequiredFields)
  useEffect(() => {
    const responsibles = oCurrentBoard.responsibles
    fnSetOCurrentBoard(oCurrentBoard)

    fnSetResponsiblesOptions(() => fnCreateResponsiblesOptions(responsibles))
  }, [])

  fnCreateDefaultValues(
    oBOardModel.fields.map((field) => field.field),
    oFilterData,
  )
  const {
    handleSubmit,
    register,
    setValue,
    watch,
    getValues,
    setError,
    formState: { errors },
    reset,
  } = useForm({
    resolver: !oBOardModel.fields.map((field) => field.field)
      ? yupResolver(fnCreateYupSchema(aAllFieldsFiltered, aRequiredFields))
      : undefined,
    defaultValues: fnCreateDefaultValues(
      oBOardModel.fields.map((field) => field.field),
      oFilterData,
    ),
  })
  const getRequiredFieldBySlug = (slug) => {
    return aRequiredFields.filter((field) => field.opfd_cslug === slug)[0]
  }
  const fnCreateResponsiblesOptions = (responsibles) => {
    const options = responsibles?.map((responsible) => {
      return { label: responsible.user_cname, value: responsible.user_nid }
    })
    return options
  }

  const fnRenderFieldsByType = (field) => {
    const statusName = {
      Pending: "Pendente",
      Done: "Concluído",
    }
    const prefixEl = field.opfd_cprefix ? <span>{field.opfd_cprefix}</span> : null
    const sufixEl = field.opfd_csuffix ? <span>{field.opfd_csuffix}</span> : null

    switch (field.opfd_ctype) {
      case "DATE":
        return (
          <DateRangeComponent
            cUserTimeZone={cUserTimeZone}
            field={field.opfd_nid}
            register={register}
            setValue={setValue}
            watch={watch}
            errors={errors}
          />
        )
      case "NUMBER":
        return (
          <RmcpNumericInputComponent
            register={register}
            getValues={getValues}
            setValue={setValue}
            errors={errors}
            field={field}
            prefixEl={prefixEl}
            sufixEl={sufixEl}
          />
        )
      case "TEXT":
        return (
          <>
            <Input
              iconLeft={prefixEl}
              iconRight={sufixEl}
              type={"text"}
              width="100%"
              {...register(`model-field-${field.opfd_nid}`)}
              placeholder="Digite para adicionar"
            />
            {errors[`model-field-${field.opfd_nid}`] && (
              <RcmpFormErrorMessage>
                {errors[`model-field-${field.opfd_nid}`].message}
              </RcmpFormErrorMessage>
            )}
          </>
        )
      case "SELECTION":
        return (
          <>
            <Select
              onClear={() => setValue(`${cSchemaPrefix}${field.opfd_nid}-select`, "")}
              onSelect={(e) => {
                setValue(`${cSchemaPrefix}${field.opfd_nid}-select`, e || null)
              }}
              defaultValue={watch(`${cSchemaPrefix}${field.opfd_nid}-select`) || ""}
              options={
                field.options.map((item) => {
                  return {
                    label:
                      field.opfd_cslug === "status"
                        ? statusName[item.opfs_coption_name]
                        : item.opfs_coption_name || "",
                    value: item.opfs_nid || "",
                  }
                }) || []
              }
              placeholder="Selecione para adicionar"
              {...register(`${cSchemaPrefix}${field.opfd_nid}-select`)}
            />
            {errors[`${cSchemaPrefix}${field.opfd_nid}-select`] && (
              <RcmpFormErrorMessage>
                {errors[`${cSchemaPrefix}${field.opfd_nid}-select`].message}
              </RcmpFormErrorMessage>
            )}
          </>
        )
      case "PEOPLES":
        return (
          <>
            <RcmpSelectUsers
              multiSelect
              searchable
              onClear={() => setValue(`model-field-${field.opfd_nid}-responsible`, "")}
              onSelect={(e) => {
                setValue(`model-field-${field.opfd_nid}-responsible`, e || null)
              }}
              defaultValue={watch(`model-field-${field.opfd_nid}-responsible`) || ""}
              placeholder="Selecione para filtrar"
              {...register(`model-field-${field.opfd_nid}-responsible`)}
            />
            {errors[`model-field-${field.opfd_nid}-people`] && (
              <RcmpFormErrorMessage>
                {errors[`model-field-${field.opfd_nid}-people`].message}
              </RcmpFormErrorMessage>
            )}
          </>
        )
      default:
        return null
    }
  }

  const fnCheckErrorsFromField = (field) => {
    const error = errors[`model-field-${field.opfd_nid}`]
    if (field.opfd_ctype === "DATE") {
      const errorStart = errors[`model-field-${field.opfd_nid}-start`]
      const errorEnd = errors[`model-field-${field.opfd_nid}-end`]
      if (errorStart || errorEnd) {
        return error.message
      }
    }
    if (error) {
      return error.message
    }
    return null
  }

  const fnHandleSubmit = async (data) => {
    try {
      const validatedData = testeSchema.validateSync(data, { abortEarly: false })
      await fnPrepareFilters(validatedData, aAllFieldsFiltered, fnHandleActivateFilter)
    } catch (error) {
      console.log("ERRO: ", error)
      if (error instanceof yup.ValidationError) {
        error.inner.forEach((err) => {
          setError(err.path, { message: err.message })
        })
      }
    }
  }

  return (
    <FormProvider>
      <form onSubmit={handleSubmit((data) => fnHandleSubmit(data))} autoComplete="off">
        <div
          className={styles.modalFilter}
          onClick={(e) => {
            fnHandleOpenFilter()
          }}
        >
          <div
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <div className={styles.modalFilter__header}>
              <p>Filtros Avançados</p>
              <CloseIcon
                fill="#fff"
                height="22px"
                width="22px"
                style={{ cursor: "pointer" }}
                onClick={fnHandleOpenFilter}
              />
            </div>
            <div className={styles.modalFilter__content}>
              <div>
                {/* {aRequiredFields.map((field) => {
                  return (
                    <div key={field.opfd_nid}>
                      <h3>{field.opfd_cname}</h3>
                      {fnRenderFieldsByType(field)}
                    </div>
                  )
                })} */}
              </div>
              <div>
                <div>
                  <h3>{getRequiredFieldBySlug("data_de_criacao").opfd_cname}</h3>
                  <DateRangeComponent
                    cUserTimeZone={cUserTimeZone}
                    field={getRequiredFieldBySlug("data_de_criacao").opfd_nid}
                    register={register}
                    setValue={setValue}
                    watch={watch}
                    errors={errors}
                  />
                </div>
              </div>
              <div>
                <div>
                  <h3>
                    {
                      aRequiredFields.filter(
                        (field) => field.opfd_cslug === "data_de_conclusao",
                      )[0].opfd_cname
                    }
                  </h3>
                  <DateRangeComponent
                    cUserTimeZone={cUserTimeZone}
                    field={
                      aRequiredFields.filter(
                        (field) => field.opfd_cslug === "data_de_conclusao",
                      )[0].opfd_nid
                    }
                    register={register}
                    setValue={setValue}
                    watch={watch}
                    errors={errors}
                  />
                </div>
              </div>
              <div>
                <div>
                  <h3>{getRequiredFieldBySlug("act_responsibles").opfd_cname}</h3>
                  <>
                    <RcmpSelectUsers
                      multiSelect
                      searchable
                      onClear={() =>
                        setValue(
                          `model-field-${getRequiredFieldBySlug("act_responsibles").opfd_nid
                          }-responsible`,
                          "",
                        )
                      }
                      onSelect={(e) => {
                        setValue(
                          `model-field-${getRequiredFieldBySlug("act_responsibles").opfd_nid
                          }-responsible`,
                          e || null,
                        )
                      }}
                      defaultValue={
                        watch(
                          `model-field-${getRequiredFieldBySlug("act_responsibles").opfd_nid
                          }-responsible`,
                        ) || ""
                      }
                      placeholder="Selecione para filtrar"
                      {...register(
                        `model-field-${getRequiredFieldBySlug("act_responsibles").opfd_nid
                        }-responsible`,
                      )}
                    />
                    {errors[
                      `model-field-${getRequiredFieldBySlug("act_responsibles").opfd_nid
                      }-people`
                    ] && (
                        <RcmpFormErrorMessage>
                          {
                            errors[
                              `model-field-${getRequiredFieldBySlug("act_responsibles").opfd_nid
                              }-people`
                            ].message
                          }
                        </RcmpFormErrorMessage>
                      )}
                  </>
                </div>
              </div>
              <div>
                {aAllFieldsFiltered.map((field) => {
                  return (
                    <div key={field.opfd_nid}>
                      <h3>{field.opfd_cname}</h3>
                      {fnRenderFieldsByType(field)}
                    </div>
                  )
                })}
              </div>
            </div>
            <div className={styles.modalFilter__footer}>
              <div>
                <Button variant="outline" onClick={fnHandleOpenFilter}>
                  Cancelar
                </Button>
                <Button
                  variant="outline"
                  onClick={(e) => {
                    e.preventDefault()

                    reset(fnCreateDefaultValues(modelSchema))
                    fnHandleClearFilter()
                  }}
                >
                  Limpar Filtros
                </Button>
              </div>
              <Button
                iconLeft={"search"}
                onClick={() => {
                  handleSubmit(fnHandleSubmit)
                }}
              >
                {" "}
                Aplicar Filtros
              </Button>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  )
}

function DateRangeComponent({ field, cUserTimeZone, register, setValue, watch, errors }) {
  const [bCanShowEndDate, fnSetBCanShowEndDate] = useState(false)
  return (
    <>
      <div className={styles.content__datepicker}>
        <RcmpDatePicker
          defaultValue={fnFormatDateFromUTCFromDate(
            watch(`model-field-${field}-start`),
            cUserTimeZone,
          )}
          {...register(`model-field-${field}-start`)}
          timePlaceholder="00:00"
          onChange={(e) => {
            /* setValue(`model-field-${field}-start`, fnFormatDateToUTC(e, cUserTimeZone)) */
            setValue(
              `model-field-${field}-start`,
              fnFormatDateToUTCFromDate(e, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
            )
            fnSetBCanShowEndDate(true)
          }}
        />{" "}
        <p>até</p>
        <RcmpDatePicker
          defaultValue={fnFormatDateFromUTCFromDate(
            watch(`model-field-${field}-end`),
            cUserTimeZone,
          )}
          {...register(`model-field-${field}-end`)}
          timePlaceholder="23:59"
          disabled={!bCanShowEndDate}
          onChange={(e) => {
            /*  setValue(`model-field-${field}-end`, fnFormatDateToUTC(e, cUserTimeZone)) */
            setValue(
              `model-field-${field}-end`,
              fnFormatDateToUTCFromDate(e, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
            )
          }}
        />
      </div>
      {errors[`model-field-${field}-start`] && (
        <RcmpFormErrorMessage>
          {errors[`model-field-${field}-start`].message}
        </RcmpFormErrorMessage>
      )}
      {errors[`model-field-${field}-end`] && (
        <RcmpFormErrorMessage>
          {errors[`model-field-${field}-end`].message}
        </RcmpFormErrorMessage>
      )}
    </>
  )
}

function RmcpNumericInputComponent(props) {
  const { field, register, errors, getValues, setValue, prefixEl, sufixEl } = props
  const cFieldName = `model-field-${props.field.opfd_nid}-number`
  function fnHandleOnChange(e) {
    const value = e?.target?.value
    const bIsDirty = getValues(cFieldName) === value
    setValue(cFieldName, value, { shouldDirty: !bIsDirty })
  }
  return (
    <NumericFormat
      customInput={RmcpNumberImput}
      decimalScale={field.opfd_nprecision || 0}
      allowLeadingZeros
      fixedDecimalScale
      decimalSeparator=","
      {...register(cFieldName)}
      field={field}
      errors={errors}
      onChange={fnHandleOnChange}
      prefixEl={prefixEl}
      sufixEl={sufixEl}
      defaultValue={getValues(cFieldName)}
    />
  )
}
function RmcpNumberImput(props) {
  return (
    <>
      <Input
        iconLeft={props.prefixEl}
        iconRight={props.sufixEl}
        type={"text"}
        width="100%"
        {...props}
        placeholder="Digite para adicionar"
      />
      {props.errors[`model-field-${props.field.opfd_nid}-number`] && (
        <RcmpFormErrorMessage>
          {props.errors[`model-field-${props.field.opfd_nid}-number`].message}
        </RcmpFormErrorMessage>
      )}
    </>
  )
}
